import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../section_title';
import { VrrTable } from '../../../shared_components';
import { prepareBody, prepareHeader } from './services';
import { TCreativeSection } from './types';
import { TCreativeElements } from '../../../../redux/creativeAnalytics/creativeVideoDetails/types';

const CreativeSection: React.FC<TCreativeSection> = ({ elements }) => {
  const { t } = useTranslation();
  const [creativeElements, setCreativeElements] = useState<
    TCreativeElements[] | undefined
  >(undefined);

  useEffect(() => {
    if (elements) {
      setCreativeElements(elements);
    }
  }, [elements]);

  return (
    <>
      <SectionTitle
        title={t('creative_video_details.section_title.creative_section')}
        iconClassName="tim-icons icon-atom"
      />
      <div className="creative_section">
        <VrrTable
          header={prepareHeader()}
          body={prepareBody(creativeElements)}
          tableProps={{
            borderless: true,
            className: 'creative-table'
          }}
          withSort
          withFilter
        />
      </div>
    </>
  );
};

export default CreativeSection;
